// @flow

import React from 'react';
import classNames from 'classnames/bind';
import style from './style.css';

type Props = {
  +children: React$Node
};

const cx = classNames.bind(style);
const stylePrefix = 'table-message';

const TableMessage = ({children}: Props) => <div className={cx(stylePrefix)}>{children}</div>;

export default TableMessage;
